<template>
  <img
    v-if="hasMediaSrc"
    :src="revMediaSrc"
    class="imageMedia"
    width="100%"
    height="100%"
  />
  <ImageEmptyState
    v-else-if="showEmptyState"
    icon="mdi-image-outline"
    class="h-100"
  />
</template>

<script>
import MediaSDK from '@/lib/ReverMediaSDK'
import { IMAGE_SIZES } from 'rever-media-sdk'
import _ from 'lodash'
import ImageEmptyState from '@/ui/shared/components/ImageEmptyState.vue'

export default {
  name: 'ImageMedia',
  props: {
    revMedia: {
      type: Object,
      required: false,
    },
    showEmptyState: {
      type: Boolean,
      required: false,
    },
  },

  components: {
    ImageEmptyState,
  },

  data() {
    return {
      revMediaSrc: '',
    }
  },
  async mounted() {
    await this.getMedia()
  },
  computed: {
    hasMediaSrc() {
      return Boolean(this.revMediaSrc)
    },
  },

  methods: {
    async getMedia() {
      if (_.isEmpty(this.revMedia)) return
      try {
        this.revMediaSrc = await MediaSDK.getImageSrc(
          this.revMedia,
          IMAGE_SIZES.SQUARE
        )
      } catch (err) {
        console.log('ERROR', err)
        this.$emit('error')
      }
    },
  },

  watch: {
    revMedia(newVal) {
      this.getMedia(newVal)
    },
  },
}
</script>
<style scoped>
.imageMedia {
  object-fit: cover;
}
</style>
